<template>
  <div class="gap-filler" @click="toggleFiller" :class="{ [status]: true, open: isOpen, 'show-status': showAnswers }">
    <div class="size-holder">{{ longuestChoice }}</div>
    <div class="placeholder">
      {{ value }}
    </div>
    <div class="choices">
      <div class="choice" v-for="(choice, index) in gap.choices" :key="'choice-' + index" @click="$emit('input', choice)">
        {{ choice }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GapFiller',
  props: {
    value: {
      type: String,
      required: true
    },
    gap: {
      type: Object,
      required: true
    },
    showAnswers: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      valueChanged: false,
      isOpen: false
    }
  },
  computed: {
    status () {
      return this.value === this.gap.goodChoice
        ? 'right'
        : 'wrong'
    },
    longuestChoice () {
      let longuest = ''
      this.gap.choices.forEach(choice => {
        if (choice.length > longuest.length) {
          longuest = choice
        }
      })
      return longuest
    }
  },
  methods: {
    toggleFiller () {
      this.isOpen = !this.isOpen
      if (!this.isOpen) {
        this.$emit('touched')
      }
    }
  }
}
</script>

<style lang="scss">
.gap-filler {
  line-height: 36px;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  margin: 0 15px;
  .size-holder {
    height: 0;
    position: relative;
    opacity: 0;
    z-index: -1;
    padding: 0 15px;
  }
  .placeholder {
    cursor: pointer;
    height: 36px;
    padding: 0 15px;
    border-bottom: 2px solid $secondary-color;
    background-color: rgba($secondary-color, 0.15);
  }
  .choices {
    transition: opacity 0.3s ease-in;
    opacity: 0;
    visibility: hidden;
    height: 0;
    position: absolute;
    background-color: #fff;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: $radius-md;
    top: 0;
    left: 0;
    .choice {
      cursor: pointer;
      height: 36px;
      padding: 0 15px;
      display: flex;
      align-items: center;
      &:hover {
        background-color: $background-color;
      }
    }
  }
  &.open {
    .choices {
      z-index: 1;
      opacity: 1;
      width: 100%;
      visibility: visible;
      height: auto;
    }
  }
  &.show-status {
    &.right, &.wrong {

    }
    &.right {
      .placeholder {
        border-bottom-color: #1bb91f;
        background-color: #fff;
        color: #1bb91f;
      }
    }
    &.wrong {
      .placeholder {
        border-bottom-color: #ff1010;
        background-color: rgba(253, 88, 42, 0.15);
        color: #ff1010;
      }
    }
  }
}
</style>
